import type { ComponentPropsWithoutRef, ReactNode, ChangeEventHandler } from 'react';
import { useId } from 'react';
import './ToggleSwitch.css';

interface ToggleSwitchInterface extends ComponentPropsWithoutRef<"input"> {
    children: ReactNode;
    className?: string;
    checked?: boolean;
    onChange?: ChangeEventHandler<HTMLInputElement>;
    tabIndex?: number;
    rest?: any
};

export type ToggleSwitchProps = ToggleSwitchInterface;

export const ToggleSwitch = ({ className, children, checked, onChange, tabIndex, ...rest }: ToggleSwitchProps) => {
    const labelId = useId();
    return (<label htmlFor={labelId} className={`toggle-switch ${className || ""}`}>
        <span className="toggle-switch-label">{children}</span>
        <span className="switch-container">
            <input id={labelId} type="checkbox" checked={checked} onChange={onChange} tabIndex={tabIndex} aria-hidden={rest["aria-hidden"]} aria-label={rest["aria-label"]} />
            <span className="slider round" />
        </span>
    </label>
    );
}
